export const platformMainPageContent = {
    en: {
    notificationsLabel: "Notifications:",
    loadingNotifications: "Loading notifications...",
    noNotifications: "No notifications found.",
    notificationFallback: "Notification",
    failedLoadNotifications: "Failed to load notifications",
    failedDeleteNotification: "Failed to delete notification",
    unknownExercises: "Unknown Exercises:",
  },
  sl: {
    notificationsLabel: "Obvestila:",
    loadingNotifications: "Nalaganje obvestil...",
    noNotifications: "Ni najdenih obvestil.",
    notificationFallback: "Obvestilo",
    failedLoadNotifications: "Napaka pri nalaganju obvestil",
    failedDeleteNotification: "Napaka pri brisanju obvestila",
    unknownExercises: "Neznane vaje:",
  },
} as const;